import { ICountry } from "./country";
import { IIndustry } from "./industry";

export enum Roles {
  OWNER = "owner",
  AGENT = "agent", // there have been role naming changes: Agent equals Broker
}

export interface ILocation {
  city?: string;
  country: ICountry;
}

export interface IHost {
  id: number;
  email: string;
  phone_number: string;
  first_name: string;
  last_name: string;
  company_name: string;
  avatarUrl: string;
  role: Roles;
  slug: string;
  company_address: string;
  location: ILocation;
}

export interface IUser {
  user: number;
  host: IHost;
  description: string;
  website: string;
  industry: IIndustry;
  international: boolean;
  reprecention_countries: ICountry[];
}

export interface IMetric {
  title: string;
  value: number;
}

export interface IUserProfileCard {
  name: string;
  host: IHost;
  metrics?: IMetric[];
}
